import React, { useState } from 'react';
import { auth } from '../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import '../assets/css/AdminDashboard.css';
import '../assets/css/Navbar.css';
import CourseContainers from '../components/CourseContainters'; // Import CourseContainers component
import CourseApplicationsPage from './CourseApplicantsPage';
import logoImage from '../assets/img/luth-logo-32x32.png';

const AdminDashboard = ({ displayName }) => {
  const courses = [
    'General Nursing',
    'Midwifery',
    'Biomedical Engineering (HND)',
    'Biomedical Engineering (ND)',
    'School of Community Health',
    'Anaesthetic Technicians',
    'Medical And Psychiatric Social Work',
    'Health Information Management (ND)',
    'Health Information Management (HND)',
    'Accident & Emergency Program',
    'Ophthalmic Program',
    'Paediatric Program',
    'Perioperative Program'
  ];

  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };
  const handleCourseSelect = course => {
    setSelectedCourse(course); // Set selected course
  };

  return (
    <div className="admin-dashboard-container">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="logo-container">
        <img src={logoImage} alt="Logo" className="logo" />
        <h3>LUTH SCHOOL ADMIN PORTAL</h3>
        </div>
        <div className="user-info-container">
          <p>Welcome, {displayName}</p>
        </div>
        <div className="logout-container">
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
      {/* Navigation Bar */}
      <div className="navigation-bar">
        <ul>
          <li>
            <a href="#Dashboard">Dashboard</a>
          </li>
          <li>
            <a href="#Applications">Applications</a>
            <div className="dropdown">
              {courses.map(course => (
                <a key={course} href="#Null" onClick={() => handleCourseSelect(course)}>
                  {course}
                </a>
              ))}
            </div>
          </li>
          <li>
            <a href="#Admission">Admission</a>
            <div className="dropdown">
              {/* Add admission options */}
            </div>
          </li>
          <li>
            <a href="#Course">Course List</a>
          </li>
          <li>
            <a href="#Student">Student List</a>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Render CourseContainers or CourseApplicationsPage based on selected course */}
        {selectedCourse ? (
          <CourseApplicationsPage courseName={selectedCourse} />
        ) : (
          <CourseContainers />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
